import request from './adminRequest'

export const enterpriseToOneApi = {
  listEnterpriseToOne (params) {
    return request.get('/enterpriseToOnes', { params: params })
  },
  getEnterpriseToOne (id) {
    return request.get('/enterpriseToOnes/' + id)
  },
  saveEnterpriseToOne (data) {
    return request.post('/enterpriseToOnes', data)
  },
  updateEnterpriseToOne (id, data) {
    return request.put('/enterpriseToOnes/' + id, data)
  },
  deleteEnterpriseToOne (id) {
    return request.delete('/enterpriseToOnes/' + id)
  },

}
export default enterpriseToOneApi
